import { render, staticRenderFns } from "./WXCW03Import.vue?vue&type=template&id=4a1c3084&"
import script from "./WXCW03Import.vue?vue&type=script&lang=js&"
export * from "./WXCW03Import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports